var map = {
	"./365-fa-logo-extended.svg": 3110,
	"./365-logo-brand.svg": 3111,
	"./365-logo-extended.svg": 2519,
	"./365-logo.svg": 2520,
	"./CaretRight.svg": 3112,
	"./arrow-right.svg": 504,
	"./calculator-arrow.svg": 1194,
	"./caret-left-circle-outline.svg": 3113,
	"./caret-left-circle.svg": 1494,
	"./caret-right-circle-outline.svg": 3114,
	"./caret-right-circle.svg": 1495,
	"./caret-right.svg": 548,
	"./carret-down-flashcards.svg": 2231,
	"./carret-down.svg": 2224,
	"./certificate-badge.svg": 1672,
	"./check.svg": 3115,
	"./checkout-minus-icon.svg": 1627,
	"./checkout-plus-icon.svg": 1628,
	"./close-icon.svg": 591,
	"./companies/logo-alphabet.svg": 1135,
	"./companies/logo-amazon-2.svg": 1136,
	"./companies/logo-amazon.svg": 1137,
	"./companies/logo-azercell.svg": 1138,
	"./companies/logo-bank-of-america.svg": 1139,
	"./companies/logo-barclays.svg": 1140,
	"./companies/logo-bbc.svg": 1141,
	"./companies/logo-bnp-paribas.svg": 1142,
	"./companies/logo-booking.svg": 1143,
	"./companies/logo-citibank.svg": 1144,
	"./companies/logo-coca-cola-white.svg": 1538,
	"./companies/logo-coca-cola.svg": 1145,
	"./companies/logo-deloitte.svg": 1146,
	"./companies/logo-experian.svg": 1147,
	"./companies/logo-facebook.svg": 1148,
	"./companies/logo-g.svg": 1539,
	"./companies/logo-goldman-sachs-new.svg": 1149,
	"./companies/logo-goldman-sachs.svg": 1540,
	"./companies/logo-google-new.svg": 1150,
	"./companies/logo-google.svg": 1151,
	"./companies/logo-h.svg": 1152,
	"./companies/logo-henkel.svg": 1153,
	"./companies/logo-hsbc-new.svg": 1154,
	"./companies/logo-hsbc.svg": 1541,
	"./companies/logo-ikea-new.svg": 1155,
	"./companies/logo-ikea.svg": 1542,
	"./companies/logo-infineon.svg": 1156,
	"./companies/logo-instagram.svg": 1157,
	"./companies/logo-jp-morgan.svg": 1158,
	"./companies/logo-jti.svg": 1159,
	"./companies/logo-linkedin.svg": 1160,
	"./companies/logo-meta-new.svg": 1161,
	"./companies/logo-meta.svg": 1543,
	"./companies/logo-morgan-stanley-new.svg": 1162,
	"./companies/logo-morgan-stanley.svg": 1544,
	"./companies/logo-netflix.svg": 1545,
	"./companies/logo-oracle.svg": 1163,
	"./companies/logo-paypal.svg": 1164,
	"./companies/logo-pwc-new.svg": 1165,
	"./companies/logo-pwc.svg": 1546,
	"./companies/logo-spotify.svg": 1547,
	"./companies/logo-tesla.svg": 1166,
	"./companies/logo-visa.svg": 1167,
	"./companies/logo-walmart.svg": 1168,
	"./companies/logo-youtube.svg": 1169,
	"./courses/arrow-right.svg": 3116,
	"./courses/clock-colored.svg": 1514,
	"./courses/clock.svg": 2213,
	"./courses/fire.svg": 3117,
	"./courses/medal-colored.svg": 2221,
	"./courses/medal.svg": 1203,
	"./courses/monitor-colored.svg": 2219,
	"./courses/monitor.svg": 1368,
	"./courses/play-circle.svg": 3118,
	"./courses/play.svg": 3119,
	"./courses/practical-tasks-colored.svg": 2220,
	"./courses/practical-tasks.svg": 3120,
	"./courses/replay.svg": 3121,
	"./curved-arrow.svg": 1130,
	"./editor/bold.svg": 3122,
	"./editor/emoji.svg": 3123,
	"./editor/image.svg": 3124,
	"./editor/italic.svg": 3125,
	"./editor/link.svg": 3126,
	"./editor/underline.svg": 3127,
	"./exams/arrow.svg": 1992,
	"./exams/correct-answer.svg": 1910,
	"./exams/excel.svg": 2208,
	"./exams/icon-star.svg": 2209,
	"./exams/incorrect-answer.svg": 1911,
	"./exams/pdf.svg": 2210,
	"./exams/python.svg": 2211,
	"./eye-closed.svg": 3128,
	"./eye-opened.svg": 3129,
	"./eye.svg": 2292,
	"./fa/fa-icon-checked-blue.svg": 3130,
	"./flashcards/browse-deck.svg": 1919,
	"./flashcards/click-hand.svg": 2295,
	"./flashcards/load-arrow.svg": 1920,
	"./flashcards/reload-deck.svg": 1918,
	"./flashcards/restart-review.svg": 3131,
	"./flashcards/review-small-eye.svg": 2230,
	"./flashcards/send-result.svg": 2229,
	"./flashcards/take-test.svg": 1921,
	"./flashcards/white-left-arrow.svg": 2297,
	"./gfx-certificate-circle.svg": 3132,
	"./gfx-certificate-excel.svg": 3133,
	"./gfx-certificate-git.svg": 3134,
	"./gfx-certificate-powerbi.svg": 3135,
	"./gfx-certificate-python.svg": 3136,
	"./gfx-certificate-r.svg": 3137,
	"./gfx-certificate-tableau.svg": 3138,
	"./gfx-certificate-theory.svg": 3139,
	"./gfx-hats-left.svg": 3140,
	"./gfx-hats-right.svg": 3141,
	"./icon-404-lms-courses.svg": 3142,
	"./icon-404-lms-practice.svg": 3143,
	"./icon-404-lms-qa.svg": 3144,
	"./icon-arrow-back.svg": 490,
	"./icon-arrow-blue.svg": 3145,
	"./icon-arrow-dropdown.svg": 2223,
	"./icon-arrow-expand.svg": 1534,
	"./icon-arrow-left.svg": 1569,
	"./icon-arrow-next.svg": 2299,
	"./icon-arrow-prev.svg": 2300,
	"./icon-arrow-right.svg": 1531,
	"./icon-arrow-up.svg": 2014,
	"./icon-arrow.svg": 1524,
	"./icon-assignment.svg": 3146,
	"./icon-audience-1.svg": 2240,
	"./icon-audience-2.svg": 2241,
	"./icon-audience-3.svg": 2242,
	"./icon-back.svg": 2047,
	"./icon-black-filled-arrow.svg": 3147,
	"./icon-bulb.svg": 3148,
	"./icon-career-track.svg": 2214,
	"./icon-certificate.svg": 2238,
	"./icon-certificates.svg": 3149,
	"./icon-check-blue-bold.svg": 3150,
	"./icon-check-circle.svg": 1515,
	"./icon-check-extreme-fucsia.svg": 3151,
	"./icon-check-list.svg": 3152,
	"./icon-check-projects.svg": 1581,
	"./icon-check.svg": 2222,
	"./icon-checkbox.svg": 3153,
	"./icon-checked-accent-light-3.svg": 3154,
	"./icon-checked-bf.svg": 3155,
	"./icon-checked-blue.svg": 3156,
	"./icon-checked-cm.svg": 3157,
	"./icon-checked-ds-accent.svg": 3158,
	"./icon-checked-extreme-blue-2.svg": 3159,
	"./icon-checked-mw.svg": 3160,
	"./icon-checked-purple.svg": 3161,
	"./icon-checked-tyf.svg": 3162,
	"./icon-checked-yellow-bold.svg": 3163,
	"./icon-checked-yellow.svg": 3164,
	"./icon-checked.svg": 3165,
	"./icon-circle-check.svg": 3166,
	"./icon-clear-filters.svg": 3167,
	"./icon-clock-colored.svg": 3168,
	"./icon-clock.svg": 2236,
	"./icon-close.svg": 484,
	"./icon-code.svg": 3169,
	"./icon-colored-google.svg": 3170,
	"./icon-colored-linkedin-fill.svg": 3171,
	"./icon-comment.svg": 1582,
	"./icon-complete-program.svg": 3172,
	"./icon-completed.svg": 3173,
	"./icon-copy-text.svg": 3174,
	"./icon-copy.svg": 1925,
	"./icon-course-banner.svg": 2013,
	"./icon-courses.svg": 3175,
	"./icon-difficulty-advanced-2.svg": 1995,
	"./icon-difficulty-advanced.svg": 2232,
	"./icon-difficulty-beginner-2.svg": 1996,
	"./icon-difficulty-beginner.svg": 2233,
	"./icon-difficulty-intermediate-2.svg": 1997,
	"./icon-difficulty-intermediate.svg": 2234,
	"./icon-down-arrow.svg": 2249,
	"./icon-download-arrow.svg": 3176,
	"./icon-download.svg": 3177,
	"./icon-download2.svg": 3178,
	"./icon-editor-bold.svg": 3179,
	"./icon-editor-code.svg": 3180,
	"./icon-editor-codeblock.svg": 3181,
	"./icon-editor-emoji.svg": 3182,
	"./icon-editor-image.svg": 3183,
	"./icon-editor-italic.svg": 3184,
	"./icon-editor-link.svg": 3185,
	"./icon-editor-strike.svg": 3186,
	"./icon-exam-clock.svg": 1914,
	"./icon-exam-download.svg": 3187,
	"./icon-exam-flag.svg": 1912,
	"./icon-exam-question.svg": 2212,
	"./icon-exam-share-result.svg": 3188,
	"./icon-exam-warning.svg": 788,
	"./icon-exams-subtract.svg": 2218,
	"./icon-exclamation.svg": 3189,
	"./icon-exit.svg": 3190,
	"./icon-facebook-white.svg": 3191,
	"./icon-facebook.svg": 3192,
	"./icon-faq-expand.svg": 665,
	"./icon-fb.svg": 1926,
	"./icon-filter-sort.svg": 1948,
	"./icon-filter.svg": 1946,
	"./icon-flashcards-arrow.svg": 2296,
	"./icon-header-back-arrow.svg": 3193,
	"./icon-help.svg": 3194,
	"./icon-home.svg": 3195,
	"./icon-info.svg": 515,
	"./icon-inlinecode.svg": 3196,
	"./icon-language.svg": 2237,
	"./icon-learn.svg": 2215,
	"./icon-library-badge-advanced.svg": 1721,
	"./icon-library-badge-beginner.svg": 1722,
	"./icon-library-badge-intermediate.svg": 1723,
	"./icon-link.svg": 3197,
	"./icon-linkedin-white.svg": 3198,
	"./icon-linkedin.svg": 1927,
	"./icon-locked.svg": 1504,
	"./icon-mail.svg": 486,
	"./icon-menu-arrow.svg": 3199,
	"./icon-menu-collapse.svg": 3200,
	"./icon-mobile-filter.svg": 3201,
	"./icon-newsfeed-comment.svg": 3202,
	"./icon-newsfeed-edit.svg": 3203,
	"./icon-newsfeed-learners.svg": 3204,
	"./icon-newsfeed-like.svg": 3205,
	"./icon-newsfeed-remove.svg": 3206,
	"./icon-newsfeed-report.svg": 3207,
	"./icon-newsfeed-snooze.svg": 3208,
	"./icon-newsfeed-trophy.svg": 3209,
	"./icon-notifications-bell.svg": 3210,
	"./icon-photo.svg": 3211,
	"./icon-pin.svg": 1563,
	"./icon-play-active.svg": 3212,
	"./icon-play.svg": 2226,
	"./icon-practice.svg": 3213,
	"./icon-price.svg": 2239,
	"./icon-pricing-arrow-down.svg": 2039,
	"./icon-pricing-badge.svg": 2038,
	"./icon-pricing-check.svg": 2042,
	"./icon-project-content.svg": 2245,
	"./icon-project-featured.svg": 2246,
	"./icon-project-files.svg": 1998,
	"./icon-project-related-courses.svg": 2248,
	"./icon-project-solution-files.svg": 2244,
	"./icon-project-topics.svg": 2247,
	"./icon-project.svg": 3214,
	"./icon-qa-ask.svg": 3215,
	"./icon-qa-delete-answer.svg": 3216,
	"./icon-qa-diamond.svg": 3217,
	"./icon-qa-edit-answer.svg": 3218,
	"./icon-qa-ellipsis-v.svg": 2254,
	"./icon-qa-follow.svg": 2252,
	"./icon-qa-followed.svg": 3219,
	"./icon-qa-glasses.svg": 3220,
	"./icon-qa-magnifier.svg": 3221,
	"./icon-qa-mark.svg": 2251,
	"./icon-qa-report.svg": 3222,
	"./icon-qa-resolve.svg": 2250,
	"./icon-qa-unassign.svg": 2253,
	"./icon-qa.svg": 3223,
	"./icon-question.svg": 787,
	"./icon-quiz.svg": 3224,
	"./icon-quote-testimonials.svg": 1213,
	"./icon-quote.svg": 2235,
	"./icon-rating-star.svg": 3225,
	"./icon-remaining-time.svg": 3226,
	"./icon-replay.svg": 3227,
	"./icon-reset.svg": 2294,
	"./icon-resources.svg": 3228,
	"./icon-scroll-top.svg": 3229,
	"./icon-search-assignment.svg": 3230,
	"./icon-search-certificate.svg": 3231,
	"./icon-search-code.svg": 3232,
	"./icon-search-course-notes.svg": 3233,
	"./icon-search-course.svg": 3234,
	"./icon-search-dataset.svg": 3235,
	"./icon-search-lesson.svg": 3236,
	"./icon-search-progress-0.svg": 3237,
	"./icon-search-progress-1.svg": 3238,
	"./icon-search-progress-2.svg": 3239,
	"./icon-search-project.svg": 3240,
	"./icon-search-questions.svg": 3241,
	"./icon-search-quiz.svg": 3242,
	"./icon-search-resource.svg": 3243,
	"./icon-search-time.svg": 3244,
	"./icon-search.svg": 693,
	"./icon-share-score.svg": 3245,
	"./icon-share.svg": 2255,
	"./icon-share2.svg": 3246,
	"./icon-shield.svg": 3247,
	"./icon-shuffle.svg": 2293,
	"./icon-site-linkedin.svg": 2243,
	"./icon-site-search.svg": 3248,
	"./icon-site-twitter.svg": 3249,
	"./icon-snooze.svg": 3250,
	"./icon-sort.svg": 1947,
	"./icon-star.svg": 3251,
	"./icon-stock-down.svg": 3252,
	"./icon-stock-up.svg": 3253,
	"./icon-subtract-unlocked.svg": 3254,
	"./icon-subtract.svg": 3255,
	"./icon-sync.svg": 1951,
	"./icon-tinymce-bold.svg": 3256,
	"./icon-tinymce-code.svg": 3257,
	"./icon-tinymce-codeblock.svg": 3258,
	"./icon-tinymce-emoji.svg": 3259,
	"./icon-tinymce-italic.svg": 3260,
	"./icon-tinymce-link.svg": 3261,
	"./icon-tinymce-strike.svg": 3262,
	"./icon-tinymce-submit.svg": 3263,
	"./icon-trash.svg": 1949,
	"./icon-trustpilot.svg": 2051,
	"./icon-twitter.svg": 1928,
	"./icon-up-arrow.svg": 1562,
	"./icon-vertical-dots.svg": 3264,
	"./icon-video-cc.svg": 3265,
	"./icon-video-full-screen.svg": 3266,
	"./icon-video-mute.svg": 3267,
	"./icon-video-pause.svg": 3268,
	"./icon-video-play.svg": 2225,
	"./icon-video-rewind.svg": 3269,
	"./icon-video-settings.svg": 3270,
	"./icon-video-transcript.svg": 3271,
	"./icon-video-volume.svg": 3272,
	"./icon-warning.svg": 3273,
	"./icon-x.svg": 3274,
	"./icon-youtube.svg": 3275,
	"./linkedin-logo.svg": 3276,
	"./medal.svg": 1529,
	"./minus-icon.svg": 2301,
	"./player/cc.svg": 3277,
	"./player/fullscreen.svg": 3278,
	"./player/mute.svg": 3279,
	"./player/pause.svg": 3280,
	"./player/play-v2.svg": 3281,
	"./player/play.svg": 3282,
	"./player/polygon.svg": 3283,
	"./player/rewind.svg": 3284,
	"./player/settings.svg": 3285,
	"./player/volume.svg": 3286,
	"./plus-icon.svg": 2302,
	"./projects-guided-unguided.svg": 3287,
	"./projects-instruction.svg": 3288,
	"./projects-quiz.svg": 3289,
	"./rounded-quotes-big.svg": 2227,
	"./rounded-quotes.svg": 3290,
	"./select-arrow.svg": 3291,
	"./select-dropdown-arrow.svg": 3292,
	"./signatures/company-linkedin.svg": 2216,
	"./signatures/company-youtube.svg": 2217,
	"./sql.svg": 3293,
	"./tech-excel.svg": 3294,
	"./tech-git.svg": 3295,
	"./tech-google-sheets.svg": 3296,
	"./tech-powerbi.svg": 3297,
	"./tech-python (2).svg": 3298,
	"./tech-python.svg": 3299,
	"./tech-r.svg": 3300,
	"./tech-responsive-artificial-intelligence.svg": 586,
	"./tech-responsive-chatgpt.svg": 679,
	"./tech-responsive-data.svg": 680,
	"./tech-responsive-excel.svg": 681,
	"./tech-responsive-git.svg": 682,
	"./tech-responsive-google-sheets.svg": 683,
	"./tech-responsive-jupyter.svg": 684,
	"./tech-responsive-multiple.svg": 685,
	"./tech-responsive-powerbi.svg": 686,
	"./tech-responsive-powerpoint.svg": 687,
	"./tech-responsive-python.svg": 688,
	"./tech-responsive-r.svg": 689,
	"./tech-responsive-sql.svg": 690,
	"./tech-responsive-tableau.svg": 691,
	"./tech-responsive-theory.svg": 692,
	"./tech-sql.svg": 3301,
	"./tech-tableau.svg": 3302,
	"./tech-theory.svg": 3303,
	"./tightly-arrow.svg": 3304,
	"./topic-responsive-business analytics.svg": 3305,
	"./topic-responsive-business-analytics.svg": 3306,
	"./topic-responsive-career-development.svg": 3307,
	"./topic-responsive-data-analysis.svg": 3308,
	"./topic-responsive-data-processing.svg": 3309,
	"./topic-responsive-data-science.svg": 3310,
	"./topic-responsive-data-visualization.svg": 3311,
	"./topic-responsive-deep-learning.svg": 3312,
	"./topic-responsive-financial-analysis.svg": 3313,
	"./topic-responsive-machine-learning.svg": 3314,
	"./topic-responsive-mathematics.svg": 3315,
	"./topic-responsive-programming.svg": 3316,
	"./vector.svg": 3317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3109;